import $ from "jquery";
import moment from "moment";
import { addCourse } from "./addCourse";
import { countryState } from "./countryState";
import { dataaccess } from "../dataaccess/dataContext";
import { application } from "../application/application";
import "jquery-mask-plugin";

let isEditing = false;
const originalValues = [];

function init() {
    $(".js-mask-decimal").mask("0999999.99");

    countryState.populateCountriesSelect("#ddlEditPersonCountry").done(function() {
        setSelectedCountry($("#txtSelectedCountry").val());
        ddlEditPersonCountryChange();
        populateddlContactPersonId();
        specialSituationClick();
        setEvents();
        saveOriginalFormValues();
    });
}

function setEvents() {
    $("#btnBasicInfoEdit").click(btnBasicInfoEditClick);

    $("#btnCancelEdit").click(btnCancelEditClick);

    $("#btnSaveEdit").click(btnSaveEditClick);

    $("#btnSubmitDraft").click(btnSubmitDraftClick);

    $("#BtnEditCourseFees").click(btnEditCourseFeesClick);

    $("#ddlContactPersonId").change(function() {
        $("#ModelContactPersonId").val($("#ddlContactPersonId").val());
    });

    $("#ddlCourseLengthId").change(function() {
        $("#txtScheduleDays").val($("#ddlCourseLengthId option:selected").data("schedule-days"));
        $("#txtCourseLengthId").val($("#ddlCourseLengthId").val());
    });

    $("#ddlCourseTypeId").change(ddlCourseTypeIdChange);

    $("#ddlEditPersonCountry").change(ddlEditPersonCountryChange);

    $("#ddlProgramId").change(function() {
        $("#txtCourseTypeId").val($(this).val());
        ddlProgramIdChange();
    });

    $("#ddlSiteId").change(ddlSiteIdChange);

    $("#ddlSpecialSituationTypeId").change(ddlSpecialSituationTypeIdChange);

    $("#downloadCommercialFileBtn").click(function() {
        window.location.href =
            "/Course/DownloadFile/" +
            "/" +
            $("#downloadCommercialFileId").val();
    });

    $("#selCommercialSupportEdit").change(selCommercialSupportEditChange);

    $("#special-situation-false").click(function() {
        specialSituationClick();
    });

    $("#special-situation-true").click(function() {
        specialSituationClick();
    });

    $("#commercial-support-true").click(function() {
        commercialSupportClick();
    });

    $("#commercial-support-false").click(function() {
        commercialSupportClick();
    });

    $("#CourseFeesForm").submit(function(e) {
        e.preventDefault();
        const $form = $(this);

        if ($form.valid() && addCourse.validateCourseFees($form)) {
            const $btnSubmit = $("#CourseFeesModal button[type=submit]");
            $btnSubmit.prop("disabled", true);

            const params = {
                "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                "data": $form.serialize(),
                "url": $form.attr("action") + "/" + $("#courseId").val(),
                "successMsg": "Course Fees have been saved."
            };

            dataaccess.post(params).done(function(result) {
                if (result.hasCourseFees === true) {
                    $("#CourseFeePlaceholder").hide();
                } else {
                    $("#CourseFeePlaceholder").show();
                }

                $("#CourseFeesModal").modal("hide");
            }).always(function() {
                $btnSubmit.prop("disabled", false);
            });
        }
    });
}
//
// Events
//
function btnBasicInfoEditClick() {
    //
    // If not isEditing then we're going to start editing so set things to edit mode
    //
    if (!isEditing) {
        $("#editIcon")
            .removeClass("fa-pen")
            .addClass("fa-times");
        $("#CourseMaterialsIncludedChk").removeAttr("disabled");
        $("#divCourseDetails .js-readonly").hide();
        $("#divCancelSaveBtns, #CourseBasicInfoForm .js-edit").removeClass("hidden");
        if ($("#courseStatusList option:selected").text() === "CRA Approved") {
            $("#CourseTypeDescription").show();
            $("#editCourseTypeDescription").addClass("hidden");
            $("#CourseLengthDescription").show();
            $("#editCourseLengthDescription").addClass("hidden");
            $("#ModelProgram").show();
            $("#editModelProgram").addClass("hidden");
            $("#ModelSite").show();
            $("#editModelSite").addClass("hidden");
        }
        const isDraft = $("#UpdateCourse_IsDraft").val() === "True";
        if (isDraft) {
            $("#btnSubmitDraft").removeClass("hidden");
        } else {
            $("#btnSubmitDraft").addClass("hidden");
        }
        populateddlProgramId();
        populateddlCourseTypeId();
        populateddlCourseLengthId();
        populateddlSiteId();
        populateddlHostSiteId();
        populateddlContactPersonId();
        populateddlSpecialSituationTypeId();
        ddlEditPersonCountryChange();
    } else {
        //
        // We were editing, now we're not so reset to not edit mode
        //
        $("#editIcon")
            .removeClass("fa-times")
            .addClass("fa-pen");
        $("#divCourseDetails .js-readonly").show();
        $("#divCancelSaveBtns, #CourseBasicInfoForm .js-edit").addClass("hidden");
        $("#CourseMaterialsIncludedChk").attr("disabled", true);
        reloadOriginalValues();
    }
    isEditing = !isEditing;
}

function btnCancelEditClick() {
    $("#CourseBasicInfoForm .errorMessage").hide();
    btnBasicInfoEditClick();
}

function btnSaveEditClick() {
    const form = $("#CourseBasicInfoForm");
    if (!validateDates()) return;
    if (!form.valid) {
        alert("Fix errors and try again");
    }
    if (form.valid) {
        form.submit();
    }
}
function btnSubmitDraftClick() {
    const isDraft = $("#UpdateCourse_IsDraft").val() === "True";
    if (!isDraft) return;
    const courseId = $("#courseId").val();
    const params = {
        url: "/Course/submitdraftcourse/" + courseId,
        successMsg: "Successfully submitted draft course."
    };
    dataaccess.post(params).done(function(data) {
        window.location.href = application.baseUrl + "/course/index/" + data.id;
    });
}

function btnEditCourseFeesClick() {
    const courseId = $("#courseId").val();
    addCourse.getCourseFees("EditCourseFeesSection", courseId);
    $("#CourseFeesModal").modal("show");
}

function ddlCourseTypeIdChange() {
    $("#txtCourseTypeId").val($("#ddlCourseTypeId").val());
    $("#txtCourseLengthId").val("");
    populateddlCourseLengthId();
}

function ddlEditPersonCountryChange() {
    const selectedCountry = $("#ddlEditPersonCountry").val();
    countryState.populateStatesSelect("#divEditNaState", "#divEditNonNaState", selectedCountry);
    $("#ddlSiteStateId").val($("#txtSelectedState").val());
    $("#ddlSiteStateId").prop("disabled", true);
}

function ddlProgramIdChange() {
    $("#ModelProgramId").val($("#ddlProgramId").val());
    const $courseType = $("#ddlCourseTypeId");
    $courseType.find("option").remove();
    initddlCourseLengthId();
    $("#ddlCourseTypeId").val("");
    ddlCourseTypeIdChange();
}

function ddlSiteIdChange() {
    initddlContactPersonId();
    $("#ModelContactPersonId").val("");
    dataaccess
        .get({ url: "/api/Site/GetSiteById/" + $("#ddlSiteId").val() })
        .done(function(result) {
            $("#ModelSiteId").val($("#ddlSiteId").val());
            $("#txtAddress").val(result.addressLine1);
            $("#txtCity").val(result.city);
            $("#ddlEditPersonCountry option")
                .filter(function() {
                    return $(this).text() === result.country.longDescription;
                })
                .prop("selected", true);
            ddlEditPersonCountryChange();
            $("#ddlSiteStateId option")
                .filter(function() {
                    return (
                        $(this).text() ===
                        (result.state == null || result.state === undefined
                            ? ""
                            : result.state.longDescription)
                    );
                })
                .prop("selected", true);
            populateddlContactPersonId();
        });
}

function ddlSpecialSituationTypeIdChange() {
    const specialSituation = $("#ddlSpecialSituationTypeId");
    if (specialSituation.find(":selected").text() === "") {
        $("#specialSituationExplanation").val("");
    } else {
        $("#ModelSpecialSituationTypeId").val($("#ddlSpecialSituationTypeId").val());
    }
}

function specialSituationClick() {
    if ($("[name=HasSpecialSituation]:checked").val() === "true") {
        $("#special-type").css("display", "inline");
        populateddlSpecialSituationTypeId();
    } else {
        $("#special-type").css("display", "none");
        $("#specialSituationExplanation").val("");
    }
}

function commercialSupportClick() {
    if ($("[name=CommercialSupport]:checked").val() === "true") {
        showCommercialSupportAlert();
    }
}
function selCommercialSupportEditChange() {
    if (this.value === "No") {
        $("#CommercialSupportEditContainer").hide();
    } else {
        $("#CommercialSupportEditContainer").show();
    }
}

//
// Functions
//

function initddlCourseTypeId() {
    $("#ddlCourseTypeId")
        .find("option")
        .remove()
        .end()
        .append(
            $("<option />")
                .val("")
                .text("Select One")
        );
}

function initddlCourseLengthId() {
    $("#ddlCourseLengthId")
        .find("option")
        .remove()
        .end()
        .append(
            $("<option />")
                .val("")
                .text("Select One")
        );
}

function initddlContactPersonId() {
    $("#ddlContactPersonId")
        .find("option")
        .remove()
        .end()
        .append(
            $("<option />")
                .val("")
                .text("Select One")
        );
}

// Reload controls from values saved in saveOriginalValues
function reloadOriginalValues() {
    for (let i = 0; i < originalValues.length; i++) {
        switch (originalValues[i].type.toLowerCase()) {
            case "email":
            case "select":
            case "text":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "checkbox":
                $("#" + originalValues[i].id).prop("checked", originalValues[i].value);
                break;
        }
    }
    ddlEditPersonCountryChange();
}

//If they edit it and click cancel we need to revert it to the model values so they are being saved here.
// Save the values of the controls, not hidden fields
//
function saveOriginalFormValues() {
    $("#divCourseDetails")
        .find("input:not([type='hidden'])")
        .each(function() {
            originalValues.push({
                id: $(this).attr("id"),
                value: $(this).is(":checkbox") ? $(this).is(":checked") : $(this).val(),
                type: $(this).attr("type") || $(this)[0].tagName
            });
        });
}

function setSelectedCountry(selectedCountry) {
    $("#ddlEditPersonCountry").val(selectedCountry);
}
function populateddlProgramId() {
    const ddlProgramId = $("#ddlProgramId");
    ddlProgramId.find("option").remove();
    dataaccess.get({ url: "/Course/program/" }).done(function(result) {
        $.each(result, function() {
            ddlProgramId.append(
                $("<option />")
                    .val(this.id)
                    .text(this.description)
            );
        });
        $("#ddlProgramId").val($("#ModelProgramId").val());
    });
}

function populateddlContactPersonId() {
    initddlContactPersonId();
    const siteId = $("#ModelSiteId").val();
    if (siteId > 0) {
        dataaccess
            .get({ url: `/api/Site/GetSiteCoordinatorsBySiteId/${siteId}` })
            .done(function(results) {
                $("#ddlContactPersonId option")
                    .filter(function() {
                        return $(this).text() === $.trim($("#ModelSiteId").text());
                    })
                    .prop("selected", true);
                for (let i = 0; i < results.length; i++) {
                    $("#ddlContactPersonId").append(
                        "<option value=" +
                        results[i].id +
                        ">" +
                        `${results[i].firstName} ${results[i].lastName}` +
                        "</option>"
                    );
                }
                $("#ddlContactPersonId").val($("#ModelContactPersonId").val());
            });
    }
}

function populateddlCourseTypeId() {
    dataaccess
        .get({ url: "/Course/GetCourseTypes/" + $("#ModelProgramId").val() })
        .done(function(results) {
            const ddlCourseTypeId = $("#ddlCourseTypeId");
            initddlCourseTypeId();
            ddlCourseTypeId.append("<option value='-1' selected>Select One</option>");
            for (let i = 0; i < results.length; i++) {
                ddlCourseTypeId.append(
                    "<option value=" + results[i].id + ">" + results[i].description + "</option>"
                );
            }
            ddlCourseTypeId.val($("#txtCourseTypeId").val());
        });
}

function populateddlSpecialSituationTypeId() {
    const specialSituation = $("#ddlSpecialSituationTypeId");
    specialSituation.find("option").remove();
    if ($("#ModelSpecialSituation").text() && $("#ModelSpecialSituationTypeId").val() !== "0") {
        $("#ddlSpecialSituationTypeId").append(
            $("<option selected/>")
                .val($("#ModelSpecialSituationTypeId").val())
                .text($("#ModelSpecialSituation").text())
        );
    }
    dataaccess.get({ url: "/Course/GetSpecialSituationTypes/" }).done(function(result) {
        $.each(result, function() {
            if ($.trim($("#ModelSpecialSituation").text()) !== this.displayName) {
                specialSituation.append(
                    $("<option />")
                        .val(this.id)
                        .text(this.description)
                );
            }
        });
    });
}

function populateddlSiteId() {
    $("#ddlSiteId").find("option").remove();
    $("#ddlSiteId").append(
        $("<option selected/>")
            .val($("#ModelSiteId").val())
            .text($("#ModelSite").text())
    );
    $("#ddlEditPersonCountry option")
        .filter(function() {
            return $(this).text() === $.trim($("#ModelCountry").text());
        })
        .prop("selected", true);
    ddlEditPersonCountryChange();
    dataaccess
        .get({ url: "/api/Site/GetSitesForSelectByPersonId/" + $("#UserId").val() })
        .done(function(result) {
            $("#ddlSiteStateId option")
                .filter(function() {
                    return $(this).text() === $.trim($("#ModelState").text());
                })
                .prop("selected", true);
            const $sites = $("#ddlSiteId");
            $.each(result, function() {
                if ($.trim($("#ModelSite").text()) !== this.description) {
                    $sites.append(
                        $("<option />")
                            .val(this.id)
                            .text(this.description)
                    );
                }
            });
        });
}

function populateddlHostSiteId() {
    $("#ddlHostSiteId").find("option").remove();
    $("#ddlHostSiteId").append(
        $("<option selected/>")
            .val($("#ModelHostSiteId").val())
            .text($("#ModelHostSite").text())
    );
    dataaccess
        .get({ url: "/api/Site/GetHostSites" })
        .done(function (result) {
            const $sites = $("#ddlHostSiteId");
            $.each(result, function () {
                if ($.trim($("#ModelHostSite").text()) !== this.description) {
                    $sites.append(
                        $("<option />")
                            .val(this.id)
                            .text(this.description)
                    );
                }
            });
        });
}

function populateddlCourseLengthId() {
    const courseTypeId = $("#txtCourseTypeId").val();
    dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function(results) {
        initddlCourseLengthId();
        let i;
        for (i = 0; i < results.length; i++) {
            $("#ddlCourseLengthId").append(
                "<option value=" +
                results[i].id +
                " data-schedule-days='" +
                results[i].scheduleDays +
                "'>" +
                results[i].description +
                "</option>"
            );
        }
        $("#ddlCourseLengthId").val($("#txtCourseLengthId").val());
    });
}

function validateDates() {
    const result = true;
    $("#ScheduleDaysRequired").hide();
    if ($("#txtStartDate").val() === "" || $("#txtEndDate").val() === "") {
        $("#ScheduleDaysRequired").show();
        return false;
    }

    const startDate = moment(new Date($("#txtStartDate").val()));
    const endDate = moment(new Date($("#txtEndDate").val()));
    const calendarDays = endDate.diff(startDate, "days") + 1;
    const scheduleDays = parseInt($("#txtScheduleDays").val());
    $("#ScheduleDaysEndLessThanStart").hide();
    if (endDate < startDate) {
        $("#ScheduleDaysEndLessThanStart").show();
        return false;
    }

    if (calendarDays === scheduleDays) {
        $("#ScheduleDaysValidation").hide();
    } else {
        const canEditDates = $("#txtStartDate:text").length === 1;
        if (canEditDates) {
            $("#ScheduleDaysValidation").show();
            return false;
        }
    }
    return result;
}

function showCommercialSupportAlert() {
    alert("You must complete and upload the Letter of Agreement (LOA) for commercial support at least 5 business days before your course.");
}

export const courseBasicInfo = {
    init: init,
    submitDraftCourse: btnSubmitDraftClick,
    showCommercialSupportAlert: showCommercialSupportAlert
};
